import { TooltipModule } from 'primeng/tooltip';
import { AtualizarClienteModule } from './pages/painel-administrativo/atualizar-cliente/atualizar-cliente.module';
import { ImagemService } from './pages/painel-administrativo/upload-image/image-service/imagem.service';
import { UpdateBdModule } from './pages/painel-administrativo/update-bd/update-bd.module';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import enUS from '@angular/common/locales/en';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsModule } from 'ng2-breadcrumbs';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { HomeModule } from './@theme/home.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './pages/app-routing.module';
import { BiTolModule } from './pages/businness-intelligence/bi-tol/bi-tol.module';
import { ComunicadoModule } from './pages/comunicado/comunicado.module';
import { ComunicadoService } from './pages/comunicado/service/comunicado.service';
import { AmpModule } from './pages/estoque/amp/amp.module';
import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';
import { NavegacaoComponent } from './pages/navegacao/navegacao.component';
import { ResultadoPaModule } from './pages/P&A/pca/resultado-pa.module';
import { VorModule } from './pages/P&A/vor/vor.module';
import { BonificacaoModule } from './pages/parametros/bonificacao/bonificacao.module';
import { BoxesModule } from './pages/parametros/boxes/boxes.module';
import { DealerModule } from './pages/parametros/dealer/dealer.module';
import { DespesaModule } from './pages/parametros/despesa/despesa.module';
import { FuncaoModule } from './pages/parametros/funcao/funcao.module';
import { GrupoEconomicoModule } from './pages/parametros/grupo-economico/grupo-economico.module';
import { GrupoImportadorModule } from './pages/parametros/grupo-importador/grupo-importador.module';
import { ProdutividadeIndiceModule } from './pages/parametros/indice-produtividade/produtividade-indice.module';
import { MargemMOModule } from './pages/parametros/margem-mo/margem-mo.module';
import { MoedaModule } from './pages/parametros/moeda/moeda.module';
import { ObjetivoVendaModule } from './pages/parametros/objetivo-venda/objetivo-venda.module';
import { PassagensModule } from './pages/parametros/passagens/passagens.module';
import { PecasAtendidasModule } from './pages/parametros/pecas-atendidas/pecas-atendidas.module';
import { PecasSolicitadasModule } from './pages/parametros/pecas-solicitadas/pecas-solicitadas.module';
import { PrevisaoCompraModule } from './pages/parametros/previsao-compra/previsao-compra.module';
import { PrevisaoVendaModule } from './pages/parametros/previsao-venda/previsao-venda.module';
import { QuartilModule } from './pages/parametros/quartil/quartil.module';
import { RegionalModule } from './pages/parametros/regional/regional.module';
import { TipoDealerModule } from './pages/parametros/tipo-dealer/tipo-dealer.module';
import { TipoItemModule } from './pages/parametros/tipo-item/tipo-item.module';
import { CargaGWMModule } from './pages/montadora/carga-gwm-lista/carga-gwm.module';
import { TipoOsModule } from './pages/parametros/tipo-os/tipo-os.module';
import { RelatorioAnaliseGeralModule } from './pages/rmpv/analises-bi/bi-relatorio-analise/bi-relatorio-analise.module';
import { AnaliseVendaBi01Module } from './pages/rmpv/analises-bi/bi01-analise-venda/analise-venda-bi01.module';
import { AnaliseMargemBi02Module } from './pages/rmpv/analises-bi/bi02-analise-margem/analise-margem-bi02.module';
import { AnalisePassagemBi03Module } from './pages/rmpv/analises-bi/bi03-analise-passagem/analise-passagem-bi03.module';
import { AnaliseEstoqueBi04Module } from './pages/rmpv/analises-bi/bi04-analise-estoque/analise-estoque-bi04.module';
import { AnaliseHoraBi05Module } from './pages/rmpv/analises-bi/bi05-analise-hora/analise-hora-bi05.module';
import { PartnumberNaoOriginalModule } from './pages/businness-intelligence/analise-part-number/partnumber-nao-original.module';
import { ProdutividadeModule } from './pages/rmpv/produtividade/produtividade.module';
import { OsModule } from './pages/rmpv/rmpv-detalhado-os/os.module';
import { RmpvDetalhadoModule } from './pages/rmpv/rmpv-detalhado/rmpv-detalhado.module';
import { RmpvDetalheProdutivoModule } from './pages/rmpv/rmpv-detalhe-produtivo/rmpv-detalhe-produtivo.module';
import { RmpvOficinaMensalModule } from './pages/rmpv/rmpv-oficina-mensal/rmpv-oficina-mensal.module';
import { RmpvOficinaModule } from './pages/rmpv/rmpv-oficina/rmpv-oficina.module';
import { RmpvPassagemMensalModule } from './pages/rmpv/rmpv-passagem-mensal/rmpv-passagem-mensal.module';
import { RmpvPassagemModule } from './pages/rmpv/rmpv-passagem/rmpv-passagem.module';
import { RmpvPecaMensalModule } from './pages/rmpv/rmpv-peca-mensal/rmpv-peca-mensal.module';
import { RmpvPecaModule } from './pages/rmpv/rmpv-peca/rmpv-peca.module';
import { ServicoModule } from './pages/status/servico/servico.module';
import { UsuarioFabricaModule } from './pages/usuario-fabrica/usuario-fabrica.module';
import { ConsultaEstoqueModule } from './pages/relatorio-veiculos/veiculo-estoque/veiculo-estoque.module';
import { PrimengTesteModule } from './pages/painel-administrativo/primeng-teste/primeng-teste.module';
import { RelatorioVeiculoDetalhadoModule } from './pages/relatorio-veiculos/relatorio-veiculo-detalhado/relatorio-veiculo-detalhado.module';
import { RelatorioVendasModule } from './pages/relatorio-veiculos/relatorio-vendas/relatorio-vendas.module';
import { SeminovosModule } from './pages/relatorio-veiculos/seminovos/seminovos.module';
import { VeiculoVendidoDetalhadoModule } from './pages/relatorio-veiculos/veiculo-vendido-detalhado/veiculo-vendido-detalhado.module';
import { VeiculoVendidoModule } from './pages/relatorio-veiculos/veiculo-vendido/veiculo-vendido.module';
import { VeiculosPedidosModule } from './pages/relatorio-veiculos/veiculos-pedidos/veiculos-pedidos.module';
import { VeiculosPropostasModule } from './pages/relatorio-veiculos/veiculos-propostas/veiculos-propostas.module';
import { AppDirective } from './security/directives/app.directive';
import { AdminComponent } from './security/guards/auth-guard/admin/admin.component';
import { AuthGuard } from './security/guards/auth-guard/auth.guard';
import { AuthenticationService } from './security/guards/auth-guard/authentication.service';
import { LogoutComponent } from './security/guards/auth-guard/logout/logout.component';
import { GuardFabrica } from './security/guards/guard.fabrica';
import { AppService } from './security/service/app.service';
import { BarraNotificacaoComponent } from './shared/barra-notificacao/barra-notificacao.component';
import { BarraNotificacaoModule } from './shared/barra-notificacao/barra-notificacao.module';
import { BarraUploadModule } from './shared/barra-upload-file/barra-upload.module';
import { ComumModule } from './shared/comum.module';
import { FileUploadModule } from './shared/fileupload/fileupload';
import { AppRoutingCache } from './shared/filter-page/app-routing-cache';
import { translateLoaderNBS } from './shared/translate-loader/translateLoader';
import { IndicadorVendaVarejoModule } from './pages/businness-intelligence/indicador-venda-varejo/indicador-venda-varejo.module';
import { IndicadorVendaVeiculoModule } from './pages/businness-intelligence/indicador-venda-veiculo/indicador-venda-veiculo.module';
import { IndicadorVendaOficinaModule } from './pages/businness-intelligence/indicador-venda-oficina/indicador-venda-oficina.module';
import { RetencaoVeiculoModule } from './pages/businness-intelligence/bi-retencao-veiculo/retencao-veiculo.module';
import { RelatorioCargaGwmModule } from './pages/montadora/relatorio-carga-gwm/relatorio-carga-gwm.module';
import { SobreListaComponent } from './pages/sobre/sobre-lista/sobre-lista.component';
import { AtualizacoesDisponiveisModule } from './pages/atualizacao/atualizacoes-disponiveis/atualizacoes-disponiveis.module';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { MonitoramentoPrecosModule } from './pages/businness-intelligence/monitoramento-precos/monitoramento-precos.module';
import { ConsultaVendaAcessoriosModule } from './pages/businness-intelligence/consulta-venda-acessorios/consulta-venda-acessorios.module';
import { CadastrarEmailModule } from './pages/parametros/cadastrar-email/cadastrar-email.module';
import { EmailService } from './pages/parametros/cadastrar-email/email-service/email.service';
import { CadastrarFabricaModule } from './pages/painel-administrativo/cadastrar-fabrica/cadastrar-fabrica.module';
import { CadastrarTipoOsModule } from './pages/painel-administrativo/cadastrar-tipo-os/cadastrar-tipo-os.module';
import { AtivacaoServicesModule } from './pages/painel-administrativo/ativacao-services/ativacao-services.module';
import { DialogModule } from 'primeng/dialog';
import { MonitoramentoAcessoriosModule } from './pages/businness-intelligence/monitoramento-acessorios/monitoramento-acessorios.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { UploadImageModule } from './pages/painel-administrativo/upload-image/upload-image.module';
import { ToolbarModule } from 'primeng/toolbar';
import { ApuracaoVDMModule } from './pages/businness-intelligence/apuracao-vdm/apuracao-vdm.module';
import { ApuracaoVDMAcessorioModule } from './pages/businness-intelligence/apuracao-vdm-acessorio/apuracao-vdm-acessorio.module';
import { RestricoesLgpdModule } from './pages/businness-intelligence/restricoes-lgpd/restricoes-lgpd.module';
import { FluxoLeadsModule } from './pages/businness-intelligence/fluxo-leads/fluxo-leads.module';
import { AtivacaoMenuModule } from './pages/painel-administrativo/ativacao-menu/ativacao-menu.module';
import {PanelMenuModule} from 'primeng/panelmenu';
import { StatusOperacaoModule } from './pages/painel-administrativo/status-operacao/status-operacao.module';
import { BancoDeDadosModule } from './pages/painel-administrativo/banco-de-dados/banco-de-dados.module';
import { MonitoramentoJobModule } from './pages/painel-administrativo/monitoramento-job/monitoramento-job.module';
import { GerenciarErrosModule } from './pages/painel-administrativo/gerenciar-erros/gerenciar-erros.module';
import { VeiculosClvModule } from './pages/relatorio-veiculos/veiculos-clv/veiculos-clv.module';
import { PorcentualClvModule } from './pages/parametros/porcentual-clv/porcentual-clv.module';
import { PedidoPecasModule } from './pages/estoque/pedido-pecas/pedido-pecas.module';
import { VeiculosRegionaisModule } from './pages/relatorio-veiculos/veiculos-regionais/veiculos-regionais.module';
import { LeadsModule } from './pages/relatorio-veiculos/leads/leads.module';
import { VisaoLeadsModule } from './pages/relatorio-veiculos/visao-leads/visao-leads.module';
import { RegionaParametroModule } from './pages/parametros/regional-parametro/regional-parametro.module';
import { FamiliaModule } from './pages/parametros/familia/familia.module';
import { VendasPendentesPecasModule } from './pages/P&A/vendas-pendentes-pecas/vendas-pendentes-pecas.module';
import { VeiculoVendidoGacModule } from './pages/relatorio-veiculos/veiculo-vendido-GAC/veiculo-vendido-GAC.module';
import { OperacoesBloqueadasModule } from './pages/painel-administrativo/operacoes-bloqueadas/operacoes-bloqueadas.module';
import { RelatorioOportunidadeModule } from './pages/businness-intelligence/relatorio-oportunidade/relatorio-oportunidade.module';
import { SignatureInterceptor } from './security/signature/signature.interceptor';
import { TipoEventoModule } from './pages/parametros/tipo-evento/tipo-evento.module';
import { TipoAndamentoModule } from './pages/parametros/tipo-andamento/tipo-andamento.module';
import { TipoParadaModule } from './pages/parametros/tipo-parada/tipo-parada.module';
import { RelatorioSpnvModule } from './pages/businness-intelligence/relatorio-spnv/relatorio-spnv.module';
import { RankingComprasModule } from './pages/businness-intelligence/ranking-compras/ranking-compras.module';
import { ConsultaPlanoFamiliaModule } from './pages/businness-intelligence/consulta-plano-familia/consulta-plano-familia.module';
import { TipoInsucessosModule } from './pages/parametros/tipo-insucessos/tipo-insucessos.module';
import { VeiculoFrequenteModule } from './pages/businness-intelligence/veiculo-frequente/veiculo-frequente.module';
import { VendaAcessorioVeiculoModule } from './pages/businness-intelligence/venda-acessorio-veiculo/venda-acessorio-veiculo.module';
import { VeiculosSemPassagensModule } from './pages/businness-intelligence/veiculos-sem-passagens/veiculos-sem-passagens.module';
import { RelatorioCoafModule } from './pages/businness-intelligence/relatorio-coaf/relatorio-coaf.module';
import { OnePageModule } from './pages/businness-intelligence/one-page/one-page.module';
import { NbsextratorModule } from './pages/painel-administrativo/nbsextrator/nbsextrator.module';

registerLocaleData(ptBr)
registerLocaleData(enUS, 'en-US')

@NgModule({
  imports: [
    HomeModule,
    ConsultaEstoqueModule,
    VeiculoFrequenteModule,
    VendaAcessorioVeiculoModule,
    VeiculoVendidoModule,
    VeiculoVendidoDetalhadoModule,
    PrevisaoVendaModule,
    PrevisaoCompraModule,
    MonitoramentoAcessoriosModule,
    TipoItemModule,
    CadastrarFabricaModule,
    CadastrarTipoOsModule,
    AtivacaoServicesModule,
    UpdateBdModule,
    IndicadorVendaVarejoModule,
    IndicadorVendaVeiculoModule,
    IndicadorVendaOficinaModule,
    MonitoramentoPrecosModule,
    ConsultaVendaAcessoriosModule,
    RetencaoVeiculoModule,
    CargaGWMModule,
    ComumModule,
    BrowserModule,
    FileUploadModule,
    BreadcrumbsModule,
    BarraNotificacaoModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DealerModule,
    TipoDealerModule,
    PassagensModule,
    PecasAtendidasModule,
    PecasSolicitadasModule,
    DespesaModule,
    BonificacaoModule,
    BoxesModule,
    MargemMOModule,
    ObjetivoVendaModule,
    GrupoImportadorModule,
    GrupoEconomicoModule,
    FuncaoModule,
    QuartilModule,
    ProdutividadeModule,
    TipoOsModule,
    UsuarioFabricaModule,
    RegionalModule,
    RmpvOficinaModule,
    RmpvOficinaMensalModule,
    RmpvDetalhadoModule,
    RmpvPassagemModule,
    RmpvPassagemMensalModule,
    RmpvPecaModule,
    RmpvPecaMensalModule,
    AnaliseVendaBi01Module,
    AnaliseMargemBi02Module,
    AnalisePassagemBi03Module,
    AnaliseEstoqueBi04Module,
    AnaliseHoraBi05Module,
    RelatorioAnaliseGeralModule,
    BrowserAnimationsModule,
    OsModule,
    RmpvDetalheProdutivoModule,
    ComunicadoModule,
    ProdutividadeIndiceModule,
    ResultadoPaModule,
    PrimengTesteModule,
    BarraUploadModule,
    SeminovosModule,
    RelatorioVendasModule,
    RelatorioVeiculoDetalhadoModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
    TreeTableModule,
    TableModule,
    TranslateModule.forRoot(translateLoaderNBS),
    NgbModule,
    MoedaModule,
    VorModule,
    AmpModule,
    BiTolModule,
    OnePageModule,
	NbsextratorModule,
    VeiculosPropostasModule,
    VeiculosPedidosModule,
    ServicoModule,
    RelatorioCargaGwmModule,
    AtualizacoesDisponiveisModule,
    BadgeModule,
    CadastrarEmailModule,
    DialogModule,
    ButtonModule,
    InputNumberModule,
    CheckboxModule,
    InputTextModule,
    AtualizarClienteModule,
    TooltipModule,
    UploadImageModule,
    ApuracaoVDMModule,
    ToolbarModule,
    ApuracaoVDMAcessorioModule,
    RestricoesLgpdModule,
    FluxoLeadsModule,
    AtivacaoMenuModule,
    PanelMenuModule,
    StatusOperacaoModule,
    BancoDeDadosModule,
    MonitoramentoJobModule,
    GerenciarErrosModule,
    VeiculosClvModule,
    PorcentualClvModule,
    PedidoPecasModule,
    VeiculosRegionaisModule,
    LeadsModule,
    VeiculosSemPassagensModule,
    VisaoLeadsModule,
    RegionaParametroModule,
    FamiliaModule,
    VendasPendentesPecasModule,
    VeiculoVendidoGacModule,
    OperacoesBloqueadasModule,
    RelatorioOportunidadeModule,
    TipoEventoModule,
    TipoAndamentoModule,
    TipoParadaModule,
    ConsultaPlanoFamiliaModule,
    TipoInsucessosModule,
    RelatorioCoafModule,
    RelatorioSpnvModule,
    RankingComprasModule,
    PartnumberNaoOriginalModule
  ],
  declarations: [
    AppComponent,
    NavegacaoComponent,
    BarraNotificacaoComponent,
    LogoutComponent,
    AdminComponent,
    NotFoundComponent,
    AppDirective,
    SobreListaComponent,
  ],
  providers: [
    AuthGuard,
    GuardFabrica,
    AppService,
    AuthenticationService,
    NgbActiveModal,
    DialogService,
    ConfirmationService,
    EmailService,
    ImagemService,
    ComunicadoService,
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: RouteReuseStrategy,
      useClass: AppRoutingCache

    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SignatureInterceptor,
      multi: true
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
//ajustado o capturar rota para fazer o registro de quem 